const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function getDaysRemaining(planExpiresAt) {
  if (!planExpiresAt) return 0;
  const ms = new Date(planExpiresAt).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / MS_PER_DAY));
}

export function hasActivePlan(user) {
  if (!user?.planExpiresAt) return false;
  return new Date(user.planExpiresAt) > new Date();
}

export function userHasAccess(user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return hasActivePlan(user);
}

export function formatDaysRemaining(days) {
  if (days === 0) return "Expired";
  if (days === 1) return "1 Day remaining";
  return `${days} Days remaining`;
}

export function getPlanLabel(user) {
  if (!user) return "—";
  if (user.role === "admin") return "Admin";
  if (!hasActivePlan(user)) return "Expired";
  return user.plan === "pro" ? "Pro" : "Free";
}

export function isPremiumUser(user) {
  if (!user) return false;
  if (user.isPremium) return true;
  if (user.role === "admin") return true;
  return user.plan === "pro" && hasActivePlan(user);
}

export const PREMIUM_API_MESSAGE =
  "This is a premium feature, please upgrade your account to use this.";
